<template>
    <div class="main">
        <download-Popup></download-Popup>
        <div class="topFixedWrap" id="topFixed">
            <p class="operamini-tips" v-if="isOperamini">Untuk memberi Anda pengalaman yang lebih baik, silakan unduh
                aplikasi profesional kami.</p>

            <p class="navBread">
                <a href="/matchs" class="match">Match</a>
                <a :href="'/matchs/' + subtitleName" id="matchSubtitJump">{{ subtitleName }}</a>
            </p>

            <!-- 顶部详情banner -->
            <div class="bannerInformWrap clearfix" id="teamWrap">
                <div class="banner-left">
                    <img class="team-logo" v-team-logo :src="getImgSrc(idData.team_A_logo)" :alt="idData.team_A_name">
                    <span class="team-name">{{ idData.team_A_name }}</span>
                </div>

                <div class="bannerCenterWrap">
                    <!-- 已结束 -->
                    <div v-if="competeStatus === 'Played'" class="w-full status_ended">
                        <p class="competename">{{ idData.competition_name }}</p>
                        <div class="scorewrap clearfix">
                            <span class="ml15">{{ idData.fs_A }}</span><b
                                class="rowLine"></b><span>{{ idData.fs_B }}</span>
                        </div>
                        <p class="time">{{ local_month_day }} {{ tran12(local_hour_minite) }}</p>
                    </div>

                    <!-- 进行中  -->
                    <div v-if="competeStatus === 'Playing'" class="w-full status_playing">
                        <p class="competename">
                            {{ idData.competition_name }}
                            <span v-if="idData.livingFlag" class="text-green">{{ idData.minute }}'</span>
                        </p>
                        <div class="scorewrap clearfix">
                            <span class="ml15">{{ idData.fs_A }}</span>
                            <b class="rowLine"></b>
                            <span>{{ idData.fs_B }}</span>
                        </div>

                        <AppMatchTag v-if="matchTagFormation.type" :type="matchTagFormation.type" />
                        <p class="unlive" v-if="!idData.livingFlag">{{ idData.minute }}'</p>
                    </div>

                    <!-- 未开始 -->
                    <div class="status_unstart" v-if="competeStatus === 'Fixture'">
                        <p class="competename">
                            <template v-if="idData.livingFlag">{{ local_month_day }} {{ tran12(local_hour_minite) }}</template>
                            {{ idData.competition_name }}
                        </p>
                        <p class="vs">VS</p>

                        <AppMatchTag v-if="matchTagFormation.type" :type="matchTagFormation.type" />
                        <div v-else class="unstartTime clearfix">
                            <span class="time">{{ local_month_day }} {{ tran12(local_hour_minite) }}</span>
                        </div>
                    </div>

                    <!-- 推迟｜其它  -->
                    <div v-if="competeStatus === 'Postponed' || competeStatus === 'Cancelled' || competeStatus === 'Suspended'"
                        class="status_unstart">
                        <p class="competename">{{ idData.competition_name }}</p>
                        <p class="vs">VS</p>
                        <div class="unstartTime clearfix">
                            <span class="time">{{ competeStatus }}</span>
                        </div>
                    </div>
                </div>

                <div class="banner-right">
                    <img class="team-logo" v-team-logo :alt="idData.team_B_name" :src="getImgSrc(idData.team_B_logo)">
                    <span class="team-name">{{ idData.team_B_name }}</span>
                </div>
            </div>

            <div class="tabWrap">
                <span :class="{ 'selected': toggleSelect === 'Ikhtisar' }" @click="toggle('Ikhtisar')">Ikhtisar</span>
                <span :class="{ 'selected': toggleSelect === 'Analisis' }" @click="toggle('Analisis')">Analysis</span>
                <span :class="{ 'selected': toggleSelect === 'Live' }" @click="toggle('Live')">Langsung HD</span>
            </div>
        </div>
        <div class="contentWrap" id="contentWrap">
            <match-overview v-show="toggleSelect === 'Ikhtisar'" class="tabContent" :matchId="competeId" />
            <match-analysis v-show="toggleSelect === 'Analisis'" class="tabContent" :matchId="competeId" />
            <match-live v-show="toggleSelect === 'Live'" :style="{ height: contentHeight }" :matchId="competeId" />
        </div>
    </div>
</template>

<script>
import messages from '@/lang/matchDetail'

import {
    downloadPopup,
    matchOverview,
    matchAnalysis,
    matchLive,
    AppMatchTag
} from '@/components'

export default {
    name: 'matchDetail',
    components: {
        downloadPopup, matchOverview, matchAnalysis, matchLive, AppMatchTag
    },
    data() {
        return {
            toggleSelect: '',
            subtitleName: '',
            competeId: null,
            idUrl: '',
            idData: {},
            idMatchAnalysisUrl: '',
            idMatchOddsUrl: '',
            idMatchOverViewUrl: '',
            competeStatus: '',
            local_month_day: '',
            local_hour_minite: '',
            currentIframeSrc: '',
            isOperamini: false,
            contentHeight: 'auto',
            matchTagFormation: {}
        }
    },
    asyncData({ store, route: { params: { id, language } } }) {
        // 此函数会在组件实例化之前执行，故直接将store,route传入；
        let locale = (language && language.split('-')[0]) || 'id'
        if (id) {
            return Promise.all([
                store.dispatch('FETCH_MATCH_DETAIL_FORMATION', { matchId: id }), // 获取详情页面部分信息
                store.dispatch('FETCH_MATCH_OVERVIEW_FORMATION', { matchId: id, locale }), // 获取overview组件需展示的信息
                store.dispatch('FETCH_MATCH_ANALYSIS_FORMATION', { matchId: id, locale, isJSON: true }), // 获取analysis组件需展示的信息
                store.dispatch('FETCH_MATCH_ODDS_EURO', { matchId: id }), // 获取odds组件euro需展示的信息
                store.dispatch('FETCH_MATCH_ODDS_ASIA', { matchId: id }), // 获取odds组件asia需展示的信息
                store.dispatch('FETCH_MATCH_ODDS_OVER_UNDER', { matchId: id }),// 获取odds组件over_under需展示的信息
                store.dispatch('FETCH_MATCH_LIVE_DATA', { matchId: id }) // 获取live组件需展示的信息
            ])
        } else {
            return Promise.reject('id不存在')
        }
    },
    head() {
        return {
            title: `${this.idData.team_A_name} VS ${this.idData.team_B_name} | ${this.idData.competition_name} | ${this.idData.date_utc} | All Sepakbola`,
            meta: [
                {
                    name: 'description',
                    content: `The live score, overview, lineup, events, technical statistics, match analysis of ${this.idData.competition_name} ${this.idData.team_A_name} vs ${this.idData.team_B_name} at ${this.idData.date_utc}`
                },
                {
                    name: 'keywords',
                    content: `${this.idData.competition_name}, ${this.idData.team_A_name}, ${this.idData.team_B_name}`
                }
            ]
        }
    },

    computed: {
        matchDetailFormation() {
            return this.$store.state.matchDetailStore.matchDetailFormation
        }
    },

    created() {
        this.competeId = this.$route.params.id
        this.subtitleName = this.$route.params.subtitle

        Object.keys(messages).map(locale => this.$i18n.setLocaleMessage(locale, messages[locale]))

        this.idData = this.matchDetailFormation.matchSample || {}
        this.idMatchAnalysisUrl = this.matchDetailFormation.matchAnalysis.url || ''
        this.idMatchOddsUrl = this.matchDetailFormation.matchOdds.url || ''
        this.idMatchOverViewUrl = this.matchDetailFormation.matchSK.url || ''
        this.competeStatus = this.idData.status || ''

        let utcTime = this.idData.start_play || ''
        this.local_month_day = this.formatData(utcTime).local_Month_Day || ''
        this.local_hour_minite = this.formatData(utcTime).local_hms || ''

        if (this.competeStatus === 'Played' || this.competeStatus === 'Playing') {
            this.currentIframeSrc = this.idMatchOverViewUrl
        } else if (this.competeStatus === 'Fixture') {
            this.currentIframeSrc = this.idMatchAnalysisUrl + '?m_station'
        }
    },

    updated() {
        let utilObj = require('@/util/util.js')
        utilObj.lazyload('teamWrap', 'team-logo')
    },

    mounted() {
        let utilObj = require('@/util/util.js')
        document.body.scrollTop = 0
        this.isOperamini = utilObj.checkOperamini()
        utilObj.timeForInOut()

        const clientHight = document.querySelector('#topFixed').clientHeight
        this.contentHeight = `calc(100vh - ${clientHight}px)`

        // 接收比赛Tag
        this.matchTagFormation = JSON.parse(localStorage.getItem("match_tag"))
        // 初始化切换到指定Tab
        this.getCurrentActiveTab()
    },

    methods: {
        getCurrentActiveTab() {
            const isLiveTab = this.matchTagFormation && this.matchTagFormation.type === '1'
            const isIkhtisarTab = this.competeStatus === 'Played' || this.competeStatus === 'Playing'

            if (isLiveTab) {
                this.toggleSelect = 'Live'
                return
            }
            if (isIkhtisarTab) {
                this.toggleSelect = 'Ikhtisar'
                return
            }
            this.toggleSelect = 'Analisis'
        },

        // 转换成12小时制方法
        tran12(time) {
            let timeArr = time.split(':')
            let result = ''
            if (timeArr[0] > 12) {
                result = (timeArr[0] - 12) + ':' + timeArr[1] + ' FM'
            } else {
                result = timeArr[0] + ':' + timeArr[1] + ' AM'
            }
            return result
        },

        toggle(toggleName) {
            document.body.scrollTop = document.documentElement.scrollTop = 0
            this.toggleSelect = toggleName
        },

        formatData(gmtDate) {
            let date = new Date(gmtDate.replace(/-/g, '/')).getTime() // 获取UTC时间戳
            let diffMin = new Date().getTimezoneOffset() // 返回UTC时间和当前计算机上的时间之间相差的分钟数。utc-当地=差分钟数;
            let localDate = new Date(date - diffMin * 60 * 1000) // 获取当地时间
            let localMonth = localDate.getMonth() + 1
            if (localMonth < 10) {
                localMonth = '0' + localMonth
            }
            let localTimeDetail = ('' + localDate).split(' ')
            let localMonthDay = localMonth + '-' + localTimeDetail[2]
            return {
                local_Month_Day: localMonthDay,
                local_hms: localTimeDetail[4].slice(0, 5)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.text-green {
    color: #16b13a;
    font-size: 0.8rem;
}

.topFixedWrap {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 999;
}

//Android
.tab-box-fixed {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
}

//iOS
.tab-box-sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 10;
}

.navBread {
    width: 100%;
    height: 2.4rem;
    background: #16b13a;
    color: #fff;
    line-height: 2.4rem;
}

.navBread a {
    padding: 0 1rem;
    text-decoration: none;
    color: #fff;
    font-size: .8rem;
}

.navBread .match {
    font-size: 1rem;
    display: inline-block;
    height: 1.2rem;
    line-height: 1.2rem;
    border-right: 0.05rem solid #119730;
}

.status_ended .scorewrap span {
    width: 2.1rem;
    height: 2.1rem;
    overflow: hidden;
    display: inline-block;
    background: rgba(255, 255, 255, 0.1);
    font-size: 2rem;
    float: left;
    border-radius: .1rem;
    text-align: center;
    line-height: 2rem;
}

.rowLine {
    float: left;
    width: .7rem;
    height: .2rem;
    display: inline-block;
    background: #fff;
    overflow: hidden;
    margin: 1rem 1rem 0;
}

.competename {
    margin-bottom: 0.6rem;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.time {
    font-size: 0.7rem;
    color: #fff;
    text-align: center;
}

.scorewrap {
    margin-bottom: 1rem;
}

.status_playing .scorewrap span {
    width: 2.2rem;
    height: 2.2rem;
    overflow: hidden;
    display: inline-block;
    background: rgba(255, 255, 255, 0.1);
    font-size: 2rem;
    float: left;
    border-radius: 0.2rem;
    ;
    color: #16b13a;
    line-height: 2.2rem;
}

.status_playing .rowLine {
    background: #16b13a;
}

.status_playing .live {
    width: 6rem;
    height: 1rem;
    background: #16bc3a;
    border-radius: 0.02666667rem;
    display: block;
    color: #fff;
    font-size: 0.68rem;
    line-height: 1rem;
    margin: 0 auto;
}

.play_arrow {
    margin: 0.25rem 0.4rem 0 1rem;
    width: 0.3rem;
    height: 0.4rem;
    float: left;
}

.unlive {
    color: #16b13a;
    font-size: 0.8rem;
}

.status_unstart {
    width: 100%;
    font-size: 0.8rem;
}

.status_unstart .vs {
    font-size: 1rem;
    margin-bottom: .9rem;
    padding-top: 0.8rem;
    text-align: center;
}

.unstartTime {
    height: 1rem;
    line-height: 1rem;
    overflow: hidden;
}

.unstartLive {
    width: 2.4rem;
    height: 0.8rem;
    line-height: 0.8rem;
    display: inline-block;
    color: #16bc3a;
    font-size: 0.6rem;
    border: 1px solid #16bc3a;
    border-radius: 0.02666667rem;
    float: left;
    margin: 0 0.2rem 0 0.4rem;
    transform: scale(0.7);
    position: relative;
    left: 0.7rem;
    top: 0.1rem;
}

.unstartTime time {
    float: left;
    font-size: 0.68rem;
}

.tabWrap {
    border-bottom: .1rem solid #eff1f4;
    width: 100%;
    height: 2.4rem;
    line-height: 2.4rem;
    background: #fff;
}

.tabWrap span {
    width: 33.3333%;
    display: inline-block;
    height: 2.4rem;
    line-height: 2.4rem;
    float: left;
    text-align: center;
    color: #606369;
    font-size: .9rem;
    // box-sizing: border-box;
}

.tabWrap span.selected {
    border-bottom: .1rem solid #16bc3a;
    color: #16bc3a;
    position: relative;
}

.contentWrap {
    position: relative;
    top: 12.2rem;
    font-size: 12px;
}

.contentWrap iframe {
    border: none;
}

.ml15 {
    margin-left: 0.8rem;
}

.operamini-tips {
    background: #FFFF00;
    text-align: center;
    font-weight: bold;
}

/* 详情banner */
.w-full{
    width: 100%;
}

.bannerInformWrap {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    height: 7.4rem;
    overflow: hidden;
    background: url(../assets/match/videoMatchBannerBg.jpg) no-repeat;
    background-size: cover;

    .banner-left,
    .banner-right {
        box-sizing: border-box;
        width: 30%;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 1.375rem;
        text-align: center;
        font-size: .7rem;
        color: #fff;

        .team-logo {
            box-sizing: border-box;
            width: 2.7rem;
            height: 2.7rem;
            margin-bottom: 1rem;
        }

        .team-name {
            box-sizing: border-box;
            width: 80% !important;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .bannerCenterWrap {
        box-sizing: border-box;
        width: 40%;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        padding: 1rem 0;
        font-size: .68rem;
        color: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// AppMatchDetail.vue?780b28fe